import type { BookingService } from '../../store/schema/BookingService';
import type { Service } from 'bookings-shared/lib/c2/services/schema/service';
import { mapSchedulingPolicyResponse } from './mapSchedulingPolicyResponse';
import getDurationInMinutes from 'bookings-c2-utils/lib/getDurationInMinutes';

export const mapServicesResponse = (response: Service[]): BookingService[] => {
    const mappedServices: BookingService[] =
        response.map((serviceItem: Service) => {
            return {
                Id: serviceItem?.serviceId,
                Description: serviceItem?.description,
                DurationMinutes: getDurationInMinutes(serviceItem?.defaultDuration),
                FormattedDuration: serviceItem?.formattedDuration,
                IsDefaultLocationOnline: serviceItem?.isLocationOnline,
                IsMultiCustomerBooking: serviceItem?.maximumAttendeesCount > 1,
                Name: serviceItem?.title,
                SchedulingPolicy: mapSchedulingPolicyResponse(
                    serviceItem?.bookingsSchedulingPolicy
                ),
                PreBuffer: getDurationInMinutes(serviceItem?.preBuffer),
                PostBuffer: getDurationInMinutes(serviceItem?.postBuffer),
                AdditionalInformation: serviceItem?.additionalInfo,
                Location: serviceItem?.defaultLocation,
                IsPrivate: serviceItem?.isPrivate,
                ServiceQuestion: serviceItem?.customQuestions,
            };
        }) ?? [];
    return mappedServices;
};
